var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C10.7452 48 -4.69686e-07 37.2548 -1.04907e-06 24C-1.62846e-06 10.7452 10.7452 3.34501e-06 24 2.76562e-06C37.2548 2.18624e-06 48 10.7452 48 24C48 37.2548 37.2548 48 24 48Z",
    fill: "#F2F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1738 16.9989C27.6896 16.9989 28.1121 17.398 28.1494 17.9042L28.1523 17.9774V31.6727C28.1523 32.1884 27.7532 32.6109 27.2471 32.6483L27.1738 32.6512H13.4785C12.9629 32.6512 12.5404 32.2521 12.5029 31.746L12.5 31.6727V17.9774C12.5 17.4617 12.8991 17.0392 13.4053 17.0018L13.4785 16.9989H27.1738ZM33.3701 19.8446C34.0874 19.4534 35 19.9231 35 20.6835V28.9667C35 29.7271 34.0874 30.1967 33.3701 29.8055L29.6191 27.7596V21.8905L33.3701 19.8446Z",
    fill: "#737A87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 20C19.1046 20 20 20.8954 20 22C20 23.1046 19.1046 24 18 24C16.8954 24 16 23.1046 16 22C16 20.8954 16.8954 20 18 20Z",
    fill: "#F2F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOpen);
export default __webpack_public_path__ + "static/media/CameraOpen.fb499033ae61a6c7d16dd265c29381f9.svg";
export { ForwardRef as ReactComponent };